<template>
  <div
    class="border-gray absolute z-60 mt-20 flex w-[calc(100vw-30px)] flex-col gap-1 rounded-lg border bg-white px-4 py-6 shadow-md md:w-[500px]"
    :class="{
      'bottom-8 left-4 md:bottom-16 md:left-8': location === 'bottom-left',
      'bottom-8 right-4 md:bottom-16 md:right-8': location === 'bottom-right',
      'left-4 top-8 md:left-8 md:top-16': location === 'top-left',
      'right-4 top-8 md:right-8 md:top-16': location === 'top-right',
    }"
  >
    <img
      class="absolute right-5 top-4 z-20 h-4 w-4 cursor-pointer"
      src="@/assets/close-icon.svg"
      alt="close icon"
      @click="$emit('close')"
    />

    <section class="flex items-center">
      <img
        v-if="iconType === 'info'"
        class="mr-2"
        src="@/assets/alert-circle.svg"
        alt="blue alert"
      />
      <img
        v-else-if="iconType === 'success'"
        class="mr-2"
        src="@/assets/verified-icon.svg"
        alt="blue alert"
      />
      <h3 class="text-left text-lg text-dark-gray">{{ title }}</h3>
    </section>

    <div class="pl-[28px]">
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
    required: true,
  },
  location: {
    type: String,
    required: false,
    default: 'bottom-left',
    validator: (value) =>
      ['bottom-left', 'bottom-right', 'top-left', 'top-right'].includes(value),
  },
  iconType: {
    type: String,
    required: false,
    default: 'info',
    validator: (value) => ['info', 'success'].includes(value),
  },
});

defineEmits(['close']);
</script>
